import newBaseApi from './newBase.api'
import type { IndicatorType, AnswerIndicatorType } from '@/types/types'

export const indicadorRespostaService = {
  ...newBaseApi,
  resource: 'indicador-de-bem-estar',
  module: 'comunicacoes',
  profile: 'aluno',
  // Methods
  getActiveIndicator: () => indicadorRespostaService.get<IndicatorType>(),
  saveAnswerIndicator: (id: string, data: AnswerIndicatorType) => indicadorRespostaService.post(`${id}/responder`, data)
}